import { InjectionToken } from '@angular/core';
import { PermissionCheckerPort } from '../ports/permission-checker.port';

export const PERMISSION_CHECKER_TOKEN = new InjectionToken<PermissionCheckerPort>('PERMISSION_CHECKER_TOKEN');